export type SubscriptionSliceType = {
  subscriptionList: SubscriptionType[];
};

export enum StatusInWords {
  active = "active",
  inactive = "inactive",
}

export type SubscriptionType = {
  id?: number;
  name: string;
  limit_campaigns: number;
  is_trial_allowed: boolean;
  status_in_words: StatusInWords;
  access_dashboard: boolean;
  access_campaign: boolean;
  access_track_sale: boolean;
  lifetime_price: number;
  disable_monthly: boolean;
  disable_annual: boolean;
  monthly_price: number;
  annually_price: number;
  is_special: boolean;
  priority: number;
  enable_assistant: boolean;
  product_id: number;
  monthly_price_id: string;
  annual_price_id: string;
};
